import {AppCtx} from "../ioc/ApplicationContext";
import {AbstractActions} from "./AbstractActions";
import {GroupPermission} from "../../generated/protocol";
import {DashboardUser} from "../../generated/protocol";
import {DashboardUserService, DASHBOARD_USER_SERVICE_NAME} from "../service/DashboardUserService";


export interface UserActions {
    logout()

    getUserInfo(afterLogin?: boolean);

    requestForbidden();

    resetForbiddenStatus();

    changeOperator(operator: number);

    loginSuccess(wrapper: { user: DashboardUser, permissions: { [key: string]: GroupPermission } });

    notLoggedIn();
}

export class UserActionsImpl extends AbstractActions implements UserActions {


    dashboardUserService: DashboardUserService;

    constructor(prop) {
        super(prop);
        this.dashboardUserService = AppCtx.resolve<DashboardUserService>(DASHBOARD_USER_SERVICE_NAME);
    }

    logout() {
        this.dashboardUserService.logout().then(() => {
            this.notLoggedIn();
        }).catch(() => {

        });
        return true;
    }

    getUserInfo(afterLogin?: boolean) {
        console.log("get user info", this);
        console.log("Loading user info ", this.dashboardUserService);
        this.dashboardUserService.loadUserInfo().then(user => {
            this.dashboardUserService.getGroupsByUser().then(map => {
                this.loginSuccess({user: user, permissions: map});
            });
        }).catch(e => {
            console.log("get user info error", this);
            console.log("Login error", e);
            if (afterLogin) {
                this.loginFailed();
            } else {
                this.notLoggedIn();
            }
        });
        return true;
    }

    requestForbidden() {
        return true;
    }

    resetForbiddenStatus() {
        return true;
    }

    loginSuccess(wrapper: { user: DashboardUser, permissions: { [key: string]: GroupPermission } }) {
        return wrapper;
    }

    loginFailed() {
        return true;
    }

    notLoggedIn() {
        return true;
    }

    changeOperator(operator: number) {
        return operator;
    }

}




// WEBPACK FOOTER //
// ./src/app/actions/UserActions.ts